<template>
  <div class="is-size-7 ff-rl"  style="position: relative;min-height: 100vh;">
    <div class="has-text-centered p-md " style="margin:auto;max-width:600px;">
      <p><img src="static/kyfbanner.png" class="image" style="margin:auto;"></p>

      <p class="is-size-5 has-text-primary">KeepYouFit, buďte stále fit a užívajte si najlepšieho fitness sprievodcu! Personalizujte svoj stravovací plán! Ty to dokážeš!</p>
      <p class="is-size-5 has-text-white">Cena 6 EUR/tyzden<br>
        Ak si chcete službu kúpiť, pošlite:<br>
        FIT na 7406</p>
      <a href="sms:7406?body=FIT+Aktivacia+predplatenej+sluzby+s+automat.+obnovou,+Cena+6EUR/tyden" class="button is-primary has-text-black is-size-3 m-md" style="width:80%">Pošlite FIT na 7406</a>
    </div>
    <Footer style="width: 100%;" />
  </div>
</template>

<script>
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'Home',
  components: {
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/SK/LP.vue